<!-- 故障原因 -->
<template>
  <div>
    <div class="list-container">
      <div class="mb20" v-for="(item, index) in list" :key="index">
        <div class="white-pre">问题详情 ：{{ item.questions }}</div>
        <div v-for="(file, fileIndex) in item.files" :key="'file' + fileIndex">
          <div
            class="flex-col-center"
            v-if="file.fileType == '0' && file.fileUrl.length > 0"
          >
            图片：
            <img
              class="flex-iamge"
              :src="iamge"
              v-for="(iamge, iamgeIndex) in file.fileUrl"
              :key="'image' + iamgeIndex"
              @click="viewImage(iamge)"
            />
          </div>

          <div
            class="flex-col-center"
            v-else-if="file.fileType == '1' && file.fileUrl.length > 0"
          >
            视频：
            <img
              class="flex-iamge"
              src="@/assets/images/video_logo.png"
              v-for="(video, videoIndex) in file.fileUrl"
              :key="'video' + videoIndex"
              @click="openUrl(video)"
            />
          </div>

          <div
            class="flex-col-center"
            v-else-if="file.fileType == '2' && file.fileUrl.length > 0"
          >
            文档：
            <img
              class="flex-iamge"
              src="@/assets/images/txt_logo.png"
              v-for="(text, textIndex) in file.fileUrl"
              :key="'text' + textIndex"
              @click="openUrl(text)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 图片查看器 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="viewerUrl"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  props: {
    failure: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      list: [], // 故障列表
      showViewer: false,
      viewerUrl: []
    }
  },
  components: {
    ElImageViewer
  },
  computed: {},
  watch: {
    failure(v) {
      if (v && v.length > 0) {
        this.formatData(v)
      }
    }
  },
  mounted() {
    this.formatData(this.failure)
  },
  methods: {
    formatData(data) {
      this.list = JSON.parse(JSON.stringify(data))
      // 整理故障文件分类
      const questions = this.list
      if (questions && questions.length > 0) {
        questions.forEach((item) => {
          let files = item.files

          if (files && files.length > 0) {
            const images = []
            const videos = []
            const other = []
            files.forEach((file) => {
              if (file.fileType == '0') {
                images.push(file.fileUrl)
              } else if (file.fileType == '1') {
                videos.push(file.fileUrl)
              } else {
                other.push(file.fileUrl)
              }
            })
            files = [
              {
                fileType: '0',
                fileUrl: images
              },
              {
                fileType: '1',
                fileUrl: videos
              },
              {
                fileType: '2',
                fileUrl: other
              }
            ]
            item.files = files
          }
        })
      }
    },

    // 查看图片
    viewImage(url) {
      this.viewerUrl = [url]
      this.showViewer = true
    },

    closeViewer() {
      this.showViewer = false
    },

    openUrl(url) {
      window.open(url)
    }
  }
}
</script>

<style lang='scss' scoped>
.list-container {
  margin-top: 10px;
}
.flex-iamge {
  width: 50px;
  height: 50px;
  margin: 5px;
  border-radius: 5px;
  object-fit: cover;
  cursor: pointer;
}
</style>
